import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/service/vioReport/index'
import { getWechattokenInHref, wechatAuth_2_0, getLocationHref } from '@/utils/utils'
import { go } from '@/libs/router'
import routes from './routes'
import Toast from '@components/common/toast'
import { mgop } from '@aligov/jssdk-mgop'
import {getDealKeyInHref, cacheXzqh} from '../utils/utils'
import {dealKeyLogin_get} from '../api/wfjb'
const CONSTS = require('../consts/const')

Vue.use(Router)
// 加载路由
const router = new Router({
  routes
})
// // 路由拦截
router.beforeEach((to, from, next) => {
  // console.log('进入路由：', to)
  //  const token = getWechattokenInHref() || ''
  //  if (token) {

  //  }

  // const token = localStorage.getItem('token') || ''
  // if (to.fullPath === '/') {
  //   // console.log(localStorage.getItem('token'), '00000')
  //   localStorage.removeItem('token')
  //  // console.log(localStorage.getItem('token'))
  //     // let that = this
 //localStorage.setItem('token', 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI3NDcwNyIsImV4cCI6MTcxMjU2NTA0MSwiZXh0ZW5kcyI6eyJpc1JlYWwiOiIxIiwiYWNjb3VudFR5cGUiOiJaV1cifX0.xn9V9ojy-xSq7_30Nba-DTRrGDqDRvpShZdUUximwJ2oANoMV5FRWQKnuwlyk__SEUIVWnR0kTvSBxoVZlwZgQ')
  //  // localStorage.setItem('token', 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5IiwiZXhwIjoxNjkxNzI5NTIyLCJleHRlbmRzIjp7ImlzUmVhbCI6IjAiLCJhY2NvdW50VHlwZSI6Impjc3MifX0.Vee4m4FVZx1W-_31YiH01CkNKiLopAykee52ajwYCXlBqyUCauXjIYAB35REFMOlJM5kK_GI60sU7Hq3dTekqQ')
  //     mgop({
  //       api: 'mgop.trustway.wfjb.auth', // 必须
  //       host: 'https://bus-jcss.police.hangzhou.gov.cn/openapi',
  //       dataType: 'JSON',
  //       type: 'GET',
  //       data: {
  //         platformId: 8
  //       },
  //       appKey: 'sjwy7hsc+2001300008+dycyyb',
  //       onSuccess: (data) => {
  //         console.log(data, '000000')
  //         // Indicator.close();
  //         if (data.data.code == 200) {
  //           if (data.data.data.isReal !== '1') {
  //             Toast.show({
  //               message: '您还未实名，请先实名'
  //               // type: 'warn'
  //             })
  //           }
  //           localStorage.setItem('token', data.data.data.token)
  //           next()
  //         } else {
  //           Toast.show({
  //             message: '获取用户token失败！'
  //             // type: 'warn'
  //           })

  //         }
  //       },
  //       onFail: (err) => {
  //         next()
  //         console.log(err, 'err--------=====--------')
  //       }
  //     })
  //   } else {
  // next()
  // }
  // console.log(MAP_KEY)
  // 如果路径在白名单内，直接跳转
  // 开发调试阶段不使用token和微信登陆
  // if (CONSTS.ENV === 'dev' || CONSTS.ENV === 'mock') {
  //   if (!token) {
  //     const platformId = localStorage.getItem('platformId') || '1'
  //     getToken({ params: { code: '', platformId, openId: 'o1ewqtzI1LfhXLXmBsrWKTd4lQ88' } }).then((result) => {
  //       if (result.data.result) {
  //         const token = result.data.data
  //         localStorage.setItem('token', token)
  //         // const locationHref = getLocationHref()
  //         next()
  //         // go(locationHref.anchor ? locationHref.baseUrl + '#' + locationHref.anchor : locationHref.baseUrl)
  //       } else {
  //         // 失败
  //         alert(result.data.data)
  //       }
  //     }).catch(() => {
  //       // TODO：获取用户token失败
  //       alert('获取用户token失败！')
  //     })
  //   } else {
  //     next()
  //   }
  //   return
  // }

  // return
  // localStorage.removeItem('wechat_code')
  // localStorage.setItem('wechat_code', code)
  // 1.获取token
  // 2.保存token到localStorage/sessionStorage
  // 缓存首个 url 上携带的 xzqh 参数，供后续 /common/ 接口透传使用
  cacheXzqh()
  const dealKey = getDealKeyInHref()
  if (dealKey) {
    dealKeyLogin_get(dealKey).then(res => {
      console.log(res.data, '000000')
      const result = res.data
      if (result) {
        localStorage.setItem('token', result.data.token)
        if (result.data.isReal !== '1') {
          Toast.show({
            message: '您还未实名，请先实名'
            // type: 'warn'
          })
        }
        next()
      } else {
        alert(result.data)
      }
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js